import { TASK_ID_QUERY_KEY } from "@src/components/widgets/Modals/ModalCommunication/CommunicationModalHeader";
import { createHref } from "@src/shims/next/router-runtime";
import { isEqual, isUndefined, mapValues, omitBy } from "lodash";
import Router, { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import { usePrevious } from "react-use";
import { getQueryParamOptional } from "../routing";
import { saveQuery } from "../url";

/**
 * updates URI without triggering refresh
 */
export const useUpdateURI = (
  params: Record<string, string>,
  /** E.g. Keep ?id=13 in URL */
  persistQueryParam?: string,
  disabled?: boolean,
) => {
  const router = useRouter();
  const prevPathname = usePrevious(router.pathname);
  const lastHref = useRef<string>();

  useEffect(() => {
    if (disabled) return;
    if (prevPathname !== router.pathname) return;

    const persistedParams = [TASK_ID_QUERY_KEY];
    if (persistQueryParam) {
      persistedParams.push(persistQueryParam);
    }

    persistedParams.forEach((persistedParam) => {
      const param = getQueryParamOptional(persistedParam, Router.query);
      if (!param) return;

      params = {
        [persistedParam]: param,
        ...params,
      };
    });

    const nextQuery = mapValues(omitBy(params, isUndefined), (value) =>
      Array.isArray(value) ? value.map(String) : String(value),
    );

    if (isEqual(Router.query, nextQuery)) return;

    const nextHref = createHref({ pathname: router.pathname, query: params });

    if (lastHref.current === nextHref) return;
    lastHref.current = nextHref;

    router.replace(nextHref, undefined, { shallow: true });

    saveQuery(params);
  }, [params, disabled]);
};
